import { Permissions } from './../../../../core/constants/permissions';
import { Component, ViewChild } from '@angular/core';
import { PatientService } from "../../../../core/services/patient.service";
import { AuthService } from "../../../../core/services/auth.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { PatientList, PatientListItem } from "../../../../core/models/patient-list.model";
import { Subscription } from "rxjs";
import { LogHelper } from 'app/core/helpers/log.helper';
import { StringHelper } from 'app/core/helpers/string-helper';
import { PatientDeleteModalComponent } from "../../../../shared/patient-delete-modal/patient-delete-modal.component";

@Component({
  selector: 'app-patient-deletion-request',
  templateUrl: './patient-deletion-request.component.html'
})
export class PatientDeletionRequestComponent {
  @ViewChild('deletePatientModal') deletePatientModal: PatientDeleteModalComponent;

  keywords: string;
  country: string;
  orderBy = 0;
  state = 2;
  results = new PatientList();
  hasResults = true;
  patientToDelete: PatientListItem;
  stringHelper = StringHelper;
  Permissions = Permissions;
  subscription: Subscription;
  activeTrialCodes: string[] = [];

  constructor(public authService: AuthService, private patientService: PatientService, private alertService: AlertService) { }

  updateFilter(keywords: string, country: string, orderBy: number = 0) {
    this.keywords = keywords === '' ? null : keywords;
    this.country = country === '' ? null : country;
    this.orderBy = orderBy;
  }

  loadPatients(page: number, keywords: string, country: string, orderBy: number) {
    // If page NULL, then it means we need to stay on the current page
    if (page == null) {
      page = this.results.currentPage ?? 1;
    }

    if (keywords === undefined)
      keywords = null;

    if (country === undefined)
      country = null;

    if (this.subscription !== undefined && this.subscription !== null && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.patientService.retrieveDeletionRequests(page, keywords, country, orderBy).subscribe({
      next: (patientList) => {
        this.results = patientList;

        if (keywords === null && country === null && patientList.results.length === 0) {
          this.hasResults = false;
        }

        // If the current page is more than the number of pages available, use reload using the last page
        if (page > patientList.totalPageCount && patientList.totalRecordCount > 0) {
          this.loadPatients(patientList.totalPageCount, keywords, country, orderBy);
        }
      },
      error: (error) => {
        this.alertService.showWarningAlert('Unable to load deletion requests!');
      }
    });
  }

  /**
   * When the delete user button is pressed, set the user to be deleted and show the delete user model to get
   * confirmation from the user that the account is to be deleted
   * @param patient
   */
  onSelectDeletePatient(patient: PatientListItem) {
    this.patientService.getActiveTrialCodesForPatient(patient.id).subscribe({
      next: response => {
        this.activeTrialCodes = response.map(r => r.code);
        this.patientToDelete = patient;
        this.deletePatientModal.show();
      },
      error: error => {
        LogHelper.log(error);
        this.alertService.showWarningAlert("Failed to get active patient trials. Please try again.");
      }
    })
  }

  onDeletedPatient(){
    this.loadPatients(null, this.keywords, this.country, 0);
  }
}
